/**
 * Copies a given string to the clipboard.
 * Uses the modern Clipboard API if available, otherwise falls back to execCommand.
 * @param {string} text - The text to copy to clipboard.
 * @returns {Promise<boolean>} Resolves true if successful, false otherwise.
 */

export async function copyToClipboard(text) {
    // console.log('Copying to clipboard:', text);
  if (
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }

  // Fallback for older browsers
  return new Promise((resolve) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    const selection = document.getSelection();
    const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
    textarea.select();
    let success = false;
    try {
      success = document.execCommand("copy");
    } catch (err) {
      success = false;
    }
    document.body.removeChild(textarea);
    if (selected) {
      selection.removeAllRanges();
      selection.addRange(selected);
    }
    resolve(success);
  });
}

/**
 * Copies the text content of a DOM element to the clipboard.
 * @param {Element|string} elementOrSelector - The element or selector whose text content will be copied.
 * @returns {Promise<boolean>} Resolves true if successful, false otherwise.
 */

export function copyElementTextToClipboard(elementOrSelector) {
    // console.log('Copying element text to clipboard:', elementOrSelector);
  let el = elementOrSelector;
  if (typeof elementOrSelector === "string") {
    el = document.querySelector(elementOrSelector);
    // console.log('Found element:', el);
  }
  if (!el) return Promise.resolve(false);
  return copyToClipboard(el.textContent || "");
}